import React, {useEffect, useState} from 'react';
import logo from "../PFC_Images/main-logo.png";
import {Link, Navigate} from "react-router-dom";
import {useAuth} from "../contexts/authContext";
import {doCreateUserWithEmailAndPassword} from "../firebase/auth";
import {db} from "../firebase/firebase";
import { auth } from "../firebase/firebase";
import {Button, Input, Select} from "@headlessui/react";
import users from '../JSONS/users.json';
import {useDarkMode} from "../contexts/darkModeContext";
import {useNotification} from "./Notifications/NotificationProvider";
import {signInWithEmailAndPassword} from "firebase/auth";


const SignUp = () => {

    const { darkMode } = useDarkMode();
    const { triggerNotification } = useNotification();


    const [fname, setFname] = useState("");
    const [lname, setLname] = useState("");


    const [phone, setPhone] = useState("");
    const [fax, setFax] = useState("");
    const [address, setAddress] = useState("");
    const [region, setRegion] = useState("");
    const [accountLevel, setAccountLevel] = useState("S");

    const [supervisor, setSupervisor] = useState("");
    const [salesCode, setSalesCode] = useState("");

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [password2, setPassword2] = useState("");

    const [isRegistering, setIsRegistering] = useState(false);


    useEffect(() => {
        const fullName = `${fname} ${lname}`;

        // Access the users array inside the data object
        const person = users[0].users.find(item => item.name === fullName);

        // If found, set the code, otherwise display a not found message
        if (person) {
            setSalesCode(person.code);
            setSupervisor(person.super);
        } else {
            setSalesCode('Sales Code Not Found');
            setSupervisor('Supervisor Not Found');
        }
    }, [fname, lname]);

    
    
    const onSubmit = async (e) => {
        e.preventDefault();
        if (password === password2) {
            if (!isRegistering) {
                setIsRegistering(true);
                try {
                    // Store the current (admin) user's credentials
                    const currentUser = auth.currentUser;
                    const adminEmail = currentUser.email;
                    const adminPassword = prompt("Please enter your password to confirm account creation:");
    
                    if (!adminPassword) {
                        alert("Account creation cancelled. Password required.");
                        setIsRegistering(false);
                        return;
                    }
    
                    // Create new user (this will automatically switch auth to the new user)
                    const userCredential = await doCreateUserWithEmailAndPassword(email, password);
                    const newUser = userCredential.user;
    
                    // Save additional user data to Firestore
                    await db.collection('Users').doc(newUser.uid).set({
                        fname,
                        lname,
                        email,
                        phone,
                        fax,
                        address,
                        region,
                        supervisor,
                        accountLevel,
                        salesCode,
                    });
    
                    // Re-authenticate the original admin user
                    await signInWithEmailAndPassword(auth, adminEmail, adminPassword);
    
                    triggerNotification("userAdded");
                    setIsRegistering(false);
                } catch (error) {
                    console.error('Error registering user:', error.message);
                    alert(`Account Registration Failed! Check to make sure all fields are correct.`);
                    triggerNotification("userAdded");
                    setIsRegistering(false);
                }
            }
        }
    };
    
    
    

    return (
        <div className={`${darkMode ? 'text-white' : 'text-black'} h-[calc(100dvh-4rem)] flex items-center justify-center p-3 w-full transition-all duration-500 ease-in-out`}>
            
            <div className={`animate-fadeIn z-20 h-fit p-6 max-w-4xl ${darkMode ? 'bg-darkMainColor border-neutral-700 text-white' : 'bg-white text-black'} w-full rounded-lg border`}>
                
                <div className="sm:mx-auto sm:w-full sm:max-w-sm">
                    {/*<img*/}
                    {/*    alt="Plant Food Company Inc."*/}
                    {/*    src={logo}*/}
                    {/*    className="mx-auto h-24 w-auto"*/}
                    {/*/>*/}
                    <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight ">
                        On Board New Account
                    </h2>
                </div>
                
                <div className="mt-10 w-full mr-auto ml-auto">
                    <form onSubmit={onSubmit} method="POST" className="grid grid-cols-6 gap-6">
                        
                        {/*Fname*/}
                        <div className={`relative col-span-3`}>
                            <label
                                className={`absolute flex -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                            >
                                First Name
                            </label>
                            <Input
                                type="text"
                                required
                                value={fname}
                                onChange={(e) => setFname(e.target.value)}
                                placeholder={`First Name`}
                                className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700 outline-2' : 'bg-white text-gray-900 outline-gray-300'} px-2 py-2 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                            />
                        </div>
                        
                        {/*Last Name*/}
                        <div className={`relative col-span-3`}>
                            <label
                                className={`absolute flex -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                            >
                                Last Name
                            </label>
                            <Input
                                type="text"
                                required
                                value={lname}
                                onChange={(e) => setLname(e.target.value)}
                                placeholder={`Last Name`}
                                className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700 outline-2' : 'bg-white text-gray-900 outline-gray-300'} px-2 py-2 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                            />
                        </div>
                        
                        
                        
                        
                        {/*Phone*/}
                        <div className={`relative col-span-3`}>
                            <label
                                className={`absolute flex -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                            >
                                Phone Number
                            </label>
                            <Input
                                type="text"
                                required
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                                placeholder={`Phone Number`}
                                className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700 outline-2' : 'bg-white text-gray-900 outline-gray-300'} px-2 py-2 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                            />
                        </div>
                        
                        {/*Fax*/}
                        <div className={`relative col-span-3`}>
                            <label
                                className={`absolute flex -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                            >
                                Fax Number
                            </label>
                            <Input
                                type="text"
                                required
                                value={fax}
                                onChange={(e) => setFax(e.target.value)}
                                placeholder={`Fax Number`}
                                className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700 outline-2' : 'bg-white text-gray-900 outline-gray-300'} px-2 py-2 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                            />
                        </div>
                        
                        
                        
                        
                        {/*Address*/}
                        <div className={`relative col-span-4`}>
                            <label
                                className={`absolute flex -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                            >
                                Address
                            </label>
                            <Input
                                type="text"
                                required
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                                placeholder={`Address`}
                                className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700 outline-2' : 'bg-white text-gray-900 outline-gray-300'} px-2 py-2 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                            />
                        </div>
                        
                        {/*Sale Industry*/}
                        <div className={`relative col-span-2`}>
                            <label
                                className={`absolute flex -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                            >
                                Region
                            </label>
                            <Select
                                required
                                value={region}
                                onChange={(e) => setRegion(e.target.value)}
                                className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700 outline-2' : 'bg-white text-gray-900 outline-gray-300'} px-2 py-2.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                            >
                                <option value="NE">North East</option>
                                <option value="SE">South East</option>
                                <option value="AG">Agriculture</option>
                                <option value="DIST">Distributor</option>
                                <option value="COM">Commercial</option>
                            </Select>
                        </div>
                        
                        
                        
                        
                        {/*Account Type*/}
                        <div className={`relative col-span-2`}>
                            <label
                                className={`absolute flex -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                            >
                                Account Level
                            </label>
                            <Select
                                required
                                value={accountLevel}
                                onChange={(e) => setAccountLevel(e.target.value)}
                                className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700 outline-2' : 'bg-white text-gray-900 outline-gray-300'} px-2 py-2.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                            >
                                <option value="S">Salesperson</option>
                                <option value="CSR">CSR (Customer Service Rep)</option>
                                <option value="PFC">PFC Fulfillment</option>
                                <option value="DIST">Distributor</option>
                                <option value="D">Developer</option>
                                <option value="A">Admin</option>
                            </Select>
                        </div>
                        
                        {/*Sales Code*/}
                        <div className={`relative col-span-2`}>
                            <label
                                className={`absolute flex -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                            >
                                Sales Code
                            </label>
                            <Input
                                type="text"
                                required
                                value={salesCode}
                                onChange={(e) => setSalesCode(e.target.value)}
                                placeholder={`Sales Code`}
                                className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700 outline-2' : 'bg-white text-gray-900 outline-gray-300'} px-2 py-2 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                            />
                        </div>
                        
                        {/*Supervisor*/}
                        <div className={`relative col-span-2`}>
                            <label
                                className={`absolute flex -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                            >
                                Supervisor
                            </label>
                            <Input
                                type="text"
                                required
                                value={supervisor}
                                onChange={(e) => setSupervisor(e.target.value)}
                                placeholder={`Supervisor`}
                                className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700 outline-2' : 'bg-white text-gray-900 outline-gray-300'} px-2 py-2 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                            />
                        </div>
                        
                        
                        {/*Email*/}
                        <div className={`relative col-span-full`}>
                            <label
                                className={`absolute flex -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                            >
                                Email
                            </label>
                            <Input
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder={`Email`}
                                className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700 outline-2' : 'bg-white text-gray-900 outline-gray-300'} px-2 py-2 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                            />
                        </div>
                        
                        {/*Password*/}
                        <div className={`relative col-span-full`}>
                            <label
                                className={`absolute flex -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                            >
                                Password
                            </label>
                            <Input
                                type="password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder={`Password`}
                                className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700 outline-2' : 'bg-white text-gray-900 outline-gray-300'} px-2 py-2 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                            />
                        </div>
                        
                        {/*Password Confirm*/}
                        <div className={`relative col-span-full`}>
                            <label
                                className={`absolute flex -top-2 left-2 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white text-gray-900'} px-1 text-xs font-medium`}
                            >
                                Password Confirm
                            </label>
                            <Input
                                type="password"
                                required
                                value={password2}
                                onChange={(e) => setPassword2(e.target.value)}
                                placeholder={`Please Type Password Again To Confirm`}
                                className={`block w-full rounded-md ${darkMode ? 'bg-darkMainColor text-white outline-neutral-700 outline-2' : 'bg-white text-gray-900 outline-gray-300'} px-2 py-2 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-green-600 sm:text-sm/6`}
                            />
                        </div>
                        
                        
                        {/*Button*/}
                        <div className={`col-span-full`}>
                            <Button
                                type="submit"
                                disabled={isRegistering}
                                className="flex w-full justify-center rounded-md bg-green-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-bgLightGreen focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            >
                                Sign Up
                            </Button>
                        </div>
                    </form>
                
                </div>
            
            </div>
            
            
        </div>
    )
};


export default SignUp;
